import { useCallback, useSyncExternalStore } from "react";

import type { ElementSetting } from "../SettingsPayload";
import { generationSettingStore } from "../store/SettingsGenerationSettingStore";

/** 1 要素の設定を購読する。無ければ undefined（未設定＝既定で動く）。 */
export function useElement(creationId: string): ElementSetting | undefined {
    const subscribe = useCallback(
        (cb: () => void) => generationSettingStore.subscribeElement(creationId, cb),
        [creationId]
    );
    const getSnapshot = useCallback(
        () => generationSettingStore.getElement(creationId),
        [creationId]
    );
    return useSyncExternalStore(subscribe, getSnapshot);
}
